import api from "../../../../BasicComponent/Service/api";
import { CHECKLIST_EXECUTION_URL } from "../../../utils/constService";

export const fetchExecutions = (params = {}) =>
  api.get(CHECKLIST_EXECUTION_URL, { params });
export const checkExistingExecution = (params = {}) =>
  api.get(`${CHECKLIST_EXECUTION_URL}/check`, { params });
export const fetchExecutionById = (id) =>
  api.get(`${CHECKLIST_EXECUTION_URL}/${id}`);
export const postExecution = (data) => api.post(CHECKLIST_EXECUTION_URL, data);
export const putExecution = (data, id) =>
  api.put(`${CHECKLIST_EXECUTION_URL}/${id}`, data);
export const deleteExecution = (id) =>
  api.delete(`${CHECKLIST_EXECUTION_URL}/${id}`);